<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="startDate"
                        :value="dataInicial"
                        :endDate="dataFinal"
                        title="data-inicio"
                        @input="changeStartDate"
                        :showClean="false"
                        :invalid="dataInicial == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="endDate"
                        :value="dataFinal"
                        :startDate="dataInicial"
                        title="data-fim"
                        @input="changeEndDate"
                        :showClean="false"
                        :invalid="dataFinal == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="rsocial"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps"
                        :value="lpsSelected"
                        :options="lpsList"
                        :loading="lpsLoading"
                        @search="carregarLps"
                        @input="updateLps"
                        label="nome"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps-bandeira"
                        :value="bandeiraSelected"
                        :options="bandeiraList"
                        :loading="bandeiraLoading"
                        @search="carregarBandeira"
                        @input="updateBandeira"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps-rede"
                        :value="redeSelected"
                        :options="redeList"
                        :loading="redeLoading"
                        @search="carregarRede"
                        @input="updateRede"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps-cidade"
                        :value="cidadeSelected"
                        :options="cidadeList"
                        :loading="cidadeLoading"
                        @search="carregarCidade"
                        @input="updateCidade"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="motivo"
                        :value="motivoSelected"
                        :options="motivoList"
                        :loading="motivoLoading"
                        @search="carregarMotivo"
                        @input="updateMotivo"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataInicial: new Date(this.$moment().subtract(30, 'days')),
            dataFinal: new Date(),
            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,
            lpsList: [],
            lpsSelected: [],
            lpsLoading: false,
            bandeiraList: [],
            bandeiraSelected: [],
            bandeiraLoading: false,
            redeList: [],
            redeSelected: [],
            redeLoading: false,
            cidadeList: [],
            cidadeSelected: [],
            cidadeLoading: false,
            motivoList: [],
            motivoSelected: [],
            motivoLoading: false,
            cargoList: [],
            cargoSelected: [],
            cargoLoading: false,
        }
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
        agrupaPorLps() {
            this.$emit('update-filtro', {
                nomeFiltro: 'agrupaPorLps',
                valor: this.agrupaPorLps,
            })
        }
    },
    methods: {
        changeStartDate(date) {
            if (date.getTime() != this.dataInicial.getTime()) {
                this.dataInicial = date;
                if (!this.isNull(this.dataInicial)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataInicial',
                        valor: this.dataInicial,
                    })
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinal.getTime()) {
                this.dataFinal = date;
                if (!this.isNull(this.dataFinal)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataFinal',
                        valor: this.dataFinal,
                    })
                }
            }
        },
        carregarClientes(searchQuery) {
            this.clienteLoading = true;
            this.$axios
                .get(`/promotor/cliente/getcombo.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 2
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar clientes.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.clienteList = response.data.content.map((c) => {
                            return {
                                id: c.idcliente,
                                rsocial: c.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.clienteList = [];
                    console.error('[RUPTURA] Erro ao carregar clientes.', e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            })
        },
        carregarLps(searchQuery) {
            this.lpsLoading = true;
            this.$axios
                .get(`/promotor/getcombo/lps.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar lps.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.lpsList = response.data.content.map((l) => {
                            return {
                                id: l.idlps,
                                nome: l.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.lpsList = [];
                    console.error('[RUPTURA] Erro ao carregar lps.', e);
                })
                .finally((_) => {
                    this.lpsLoading = false;
                });
        },
        updateLps(lps) {
            this.lpsSelected = lps;
            this.$emit('update-filtro', {
                nomeFiltro: 'idLpsList',
                valor:
                    this.lpsSelected.length == 0 ? [] : this.lpsSelected.map((l) => l.id),
            })
        },
        carregarBandeira(searchQuery) {
            this.bandeiraLoading = true;
            this.$axios
                .get(`/promotor/getcombo/division.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 250
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_FATURAMENTO] Erro status ${r.status} ao carregar bandeira.`);
                        console.error(`[PRO_FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.bandeiraList = response.data.content.map((item) => {
                            return {
                                id: item.idprobandeira,
                                descricao: item.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.bandeiraList = [];
                    console.error('[PRO_FATURAMENTO] Erro ao carregar bandeira.', e);
                })
                .finally((_) => {
                    this.bandeiraLoading = false;
                });
        },
        updateBandeira(value) {
            this.bandeiraSelected = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'idBandeiraList',
                valor: this.bandeiraSelected.length == 0 ? [] : this.bandeiraSelected.map((item) => item.id),
            })
        },
        carregarRede(searchQuery) {
            this.redeLoading = true;
            this.$axios
                .get(`/pro/rede/getcombo.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 250
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_FATURAMENTO] Erro status ${r.status} ao carregar rede.`);
                        console.error(`[PRO_FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.redeList = response.data.content.map((item) => {
                            return {
                                id: item.idprorede,
                                descricao: item.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.redeList = [];
                    console.error('[PRO_FATURAMENTO] Erro ao carregar rede.', e);
                })
                .finally((_) => {
                    this.redeLoading = false;
                });
        },
        updateRede(value) {
            this.redeSelected = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'idRedeList',
                valor: this.redeSelected.length == 0 ? [] : this.redeSelected.map((item) => item.id),
            })
        },
        carregarCidade(searchQuery) {
            this.cidadeLoading = true;
            this.$axios
                .get(`/general/getcombo/city.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 250
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_FATURAMENTO] Erro status ${r.status} ao carregar cidade.`);
                        console.error(`[PRO_FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.cidadeList = response.data.content.map((item) => {
                            return {
                                id: item.idcidade,
                                descricao: item.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.cidadeList = [];
                    console.error('[PRO_FATURAMENTO] Erro ao carregar cidade.', e);
                })
                .finally((_) => {
                    this.cidadeLoading = false;
                });
        },
        updateCidade(value) {
            this.cidadeSelected = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'idCidadeList',
                valor: this.cidadeSelected.length == 0 ? [] : this.cidadeSelected.map((item) => item.id),
            })
        },
        carregarMotivo(searchQuery) {
            this.motivoLoading = true;
            this.$axios
                .get(`/promotor/motivovisita/getcombo.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 250
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_FATURAMENTO] Erro status ${r.status} ao carregar tipoServico.`);
                        console.error(`[PRO_FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.motivoList = response.data.content.map((item) => {
                            return {
                                id: item.idmotivovisita,
                                descricao: item.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.motivoList = [];
                    console.error('[PRO_FATURAMENTO] Erro ao carregar tipoServico.', e);
                })
                .finally((_) => {
                    this.motivoLoading = false;
                });
        },
        updateMotivo(value) {
            this.motivoSelected = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'idMotivoList',
                valor: this.motivoSelected.length == 0 ? [] : this.motivoSelected.map((item) => item.id),
            })
        },
        carregarColaboradorCargo(searchQuery) {
            this.cargoLoading = true;
            this.$axios
                .get(`/pro/cargo/findallcombo.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 250
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_FATURAMENTO] Erro status ${r.status} ao carregar colaboradorCargo.`);
                        console.error(`[PRO_FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.cargoList = response.data.content.map((item) => {
                            return {
                                id: item.idusuariocargo,
                                descricao: item.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.cargoList = [];
                    console.error('[PRO_FATURAMENTO] Erro ao carregar colaboradorCargo.', e);
                })
                .finally((_) => {
                    this.cargoLoading = false;
                });
        },
        updateColaboradorCargo(value) {
            this.cargoSelected = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'idCargoList',
                valor: this.cargoSelected.length == 0 ? [] : this.cargoSelected.map((item) => item.id),
            })
        },
        clearFilter() {
            this.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.dataFinal = new Date();
            this.clienteSelected = [];
            this.lpsSelected = [];
            this.bandeiraSelected = [];
            this.redeSelected =[];
            this.cidadeSelected = [];
            this.motivoSelected = [];
            this.cargoSelected = [];
        },
    }
}
</script>